import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { DateTimeField, LocalizationProvider } from "@mui/x-date-pickers";
import { getCostTypes } from "../../actions/costs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { connect, useStore } from "react-redux";
import { Link, Navigate, useLocation } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { CreateReport, UpdateReport } from "../../actions/notification";
import { updateCost } from "../../actions/costs";
import { getNotification } from "../../actions/notification";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper/Paper";
import Typography from "@mui/material/Typography/Typography";
import moment from "moment";
import { Theme247 } from "../../styles/Theme247";
import { ApplyStyle as _s } from "../../utils/ApplyStyle";
import NotificationAttachments from "../NotificationDetailsPage/NotificationAttachments";
import axios, * as others from "axios";
import store from "../../store";
// import { getUnits } from "../../shared-functions/units";
import { UpdateNotification } from "../../actions/notification";
import { getItem } from "../../utils/DataProtection";
import { withCurrentAccountPrefix } from "../../utils/accountMode";

import {
  getUnits,
} from "../../actions/counters";



var do_once = true;
export default connect(
  ({ enterprises, isAuthUser, machines, i18n, notification, costtypes,units }) => ({
    enterprises,
    isAuthUser,
    machines,
    i18n,
    notification,
    costtypes,
    getCostTypes,
    units
  }),
  {
    CreateReport,
    UpdateReport,
    getCostTypes,
    getNotification,
    updateCost,
    UpdateNotification,
    getUnits
  }
)((props) => {
  const i18n = props.i18n;
  const store = useStore().getState();

  const [comment, setcomment] = useState("");

  const [machinepoolid, setmachinepoolid] = useState("");
  const [values, setValues] = React.useState({
    showPassword: false,
  });

  const [navigate, setNavigate] = useState(false);
  let location = useLocation();
  /* console.log(props, "props?"); */

  const [execution, setexecution] = React.useState(
    moment(Date.now()).format("YYYY-MM-DD")
  );
  const [n_time, setn_time] = useState();
  const [nodeId, setNodeId] = useState();

  useEffect(() => {
    if (props && props?.pageType == "edit") {
      setexecution(props?.date);
      setn_time(props?.time);
      setcomment(props?.comment);
      setNodeId(nodeId);
    }
    props.getCostTypes("", "COST_TYPES");
  }, []);

  const [noti_loader, setnoti_loader] = useState(false);

  /*
   * Styles
   */
  const useStyles = makeStyles()((theme) => ({
    elevatedSection: {
      ...theme.elevatedSection,
    },
    sectionHeader: {
      ...theme.sectionHeader,
    },
    sectionDivider: {
      marginBottom: 28,
    },
  }));
  const { classes } = useStyles(props, {
    props: props,
  });

  const [noti_image_data, setnoti_image_data] = useState([]);
  const [noti_video_data, setnoti_video_data] = useState([]);
  const [noti_docs_data, setnoti_docs_data] = useState([]);

  const receiveChildValueAttachment = (images, videos, docs) => {
    setnoti_image_data(images);
    setnoti_video_data(videos);
    setnoti_docs_data(docs);
  };

  const handleDate = (e) => {
    setexecution(e.target.value);
  };

  const handletime = (e) => {
    setn_time(e.target.value);
  };

  const getDateFromTimestamp = (unixTimeStamp) => {
    let date = new Date(unixTimeStamp);
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 <= 9
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate())
    );
  };
  const getTimeFromTimestamp = (unixTimeStamp) => {
    let date = new Date(unixTimeStamp);
    return (
      date.getHours() +
      ":" +
      (date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes())
    );
  };

  const creation_date = getDateFromTimestamp(Date.now());
  const creation_time = getTimeFromTimestamp(Date.now());

  const {units} = props;

  let userProfile = store.userProfile;

  const [realName, setRealName] = useState(
    (props && props.auther) ||
      userProfile?.user?.givenname + " " + userProfile?.user?.surname
  );

  const [textFields, setTextFields] = useState([]);
  const [fullname, setFullName] = useState(
    (props && props.authorsignature) || ""
  );

  const [createdDate, setCreatedDate] = useState(
    props?.pageType === "edit"
      ? moment.unix(props?.created / 1000).format("YYYY-MM-DD")
      : moment(Date.now()).format("YYYY-MM-DD")
  );

  const handleCreatedDateChange = (e) => {
    setCreatedDate(e.target.value);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setnoti_loader(true);

    //attachments
    const attachmentObject = {
      HEADER: {
        LANGUAGE_VERSION: "1.0.0",
      },

      OBJECTS: [],
    };
    let urlArray = []; // unknown # of urls (1 or more)
    var fileurls = [];
    let promiseArray = [];
    var attachments = [];
    const config = {
      headers: {
        "Content-Type": "application/octet-stream",
        "Access-Control-Allow-Origin": "*",
      },
    };
    if (noti_image_data.length > 0) {
      for (var i = 0; i < noti_image_data.length; i++) {
        const response = await fetch(noti_image_data[i].image);
        const imgBlob = await response.blob();

        promiseArray.push(
          axios.put(noti_image_data[i].url, noti_image_data[i].image, config)
        );
        const image = {
          nodeid: noti_image_data[i].nodeid,
          fileid: noti_image_data[i].fileid,
          mimetype: noti_image_data[i].mime,
          bucketid: noti_image_data[i].bucketid,
          fileversion: noti_image_data[i].fileversion,
        };
        attachments.push(image);
      }
    }

    if (noti_video_data.length > 0) {
      for (var i = 0; i < noti_video_data.length; i++) {
        const response = await fetch(noti_video_data[i].image);
        const imgBlob = await response.blob();

        promiseArray.push(
          axios.put(noti_video_data[i].url, noti_video_data[i].image, config)
        );
        const image = {
          nodeid: noti_video_data[i].nodeid,
          fileid: noti_video_data[i].fileid,
          mimetype: noti_video_data[i].mime,
          bucketid: noti_video_data[i].bucketid,
          fileversion: noti_video_data[i].fileversion,
        };
        attachments.push(image);
      }
    }
    if (noti_docs_data.length > 0) {
      for (var i = 0; i < noti_docs_data.length; i++) {
        const response = await fetch(noti_docs_data[i].image);
        const imgBlob = await response.blob();

        promiseArray.push(
          axios.put(noti_docs_data[i].url, noti_docs_data[i].image, config)
        );
        const image = {
          nodeid: noti_docs_data[i].nodeid,
          fileid: noti_docs_data[i].fileid,
          mimetype: noti_docs_data[i].mime,
          bucketid: noti_docs_data[i].bucketid,
          fileversion: noti_docs_data[i].fileversion,
          title: noti_docs_data[i].title,
          description: noti_docs_data[i].description,
        };
        attachments.push(image);
      }
    }

    const response = await axios.all(promiseArray).then(function(results) {
      var ok = results.map((r) => r.data);
      return ok;
    });
    const created = Date.now();
    const usernodeid = JSON.parse(getItem("usernodeid"));
    const notificationnodeid = props?.notificationnodeid;

    const datetime = execution + " " + n_time + ":00.999";
    var dt = new Date(datetime);
    var executed = dt.getTime();
    if (isNaN(executed) || executed == null || executed == undefined) {
      if (execution == undefined && n_time != undefined) {
        const datetime = creation_date + " " + n_time + ":00.999";
        var dt = new Date(datetime);
        executed = dt.getTime();
      } else if (execution != undefined && n_time == undefined) {
        const datetime = creation_date + " " + creation_time + ":00.999";
        var dt = new Date(datetime);
        executed = dt.getTime();
      } else {
        executed = Date.now();
      }
    }
    const lang = "de";

    if (props?.pageType == "edit") {
      const attachmentType = "Create";
      const reportnodeid = props?.reportnodeid;
      let authorsignature = fullname;
      let created = moment(createdDate).format("X") * 1000;
      props.UpdateReport(
        {
          lang,
          executed,
          comment,
          authorsignature,
          created,
          reportnodeid,
          attachmentType,
          attachments,
        },
        "UPDATEREPORT"
      );

      // updating Costs...
      textFields.length > 0 &&
        textFields.map((item) => {
          props.updateCost({
            lang: store.language,
            nodeid: item.nodeid,
            name: item.name,
            value: parseFloat(item.value),
            costTypeNodeId: item.costTypeNodeId,
            hasCostSourceNodeId: item.hasCostSourceNodeId,
            specifier: item.specifier,
          });
        });

      props.getNotification(
        { nodeid: props.notification?.notification?.nodeid },
        "GETSINGLENOTIFICATION"
      );
    } else {
      const tempArray = [];
      textFields.map((item, k) => {
        tempArray.push({
          lang: store.language,
          name: item.name,
          value: parseFloat(item.value),
          specifier: "actualcost",
          costTypeNodeId: item.costTypeNodeId,
          hasCostSourceNodeId: item.hasCostSourceNodeId,
        });
      });

      let authorsignature = fullname;
      let created = moment(createdDate).format("X") * 1000;
      props.CreateReport({
        lang,
        executed,
        comment,
        authorsignature,
        created,
        usernodeid,
        notificationnodeid,
        attachments,
      });

      // updating Costs...
      textFields.length > 0 &&
        textFields.map((item) => {
          props.updateCost({
            lang: store.language,
            nodeid: item.nodeid,
            name: item.name,
            value: parseFloat(item.value),
            costTypeNodeId: item.costTypeNodeId,
            hasCostSourceNodeId: item.hasCostSourceNodeId,
            specifier: item.specifier,
          });
        });

      let payload = {
        nodeid: notificationnodeid,
        status: 2,
        previousStatus: 0,
        onlyStatusUpdate: true,
        progressstarted: 1703154984204,
        type: props?.notification?.notification?.type,
        closed: moment(Date.now()),
        title: props?.notification?.notification?.title,
        description: props?.notification?.notification?.description,
        equipmentnodeid:
          props?.notification?.notification?.isnotificationof &&
          props?.notification?.notification?.isnotificationof[0]?.equipment
            ?.nodeid,
      };

      props.UpdateNotification(payload, "UPDATENOTIFICATIONSTATUS");
    }

    setnoti_loader(false);
    setNavigate(true);
  };

  const handleTextFieldChange = (
    hasCostSourceNodeId,
    specifier,
    id,
    nodeid,
    costTypeNodeId,
    name,
    value
  ) => {
    setTextFields((textFields) => {
      const index = textFields.findIndex((tf) => tf.id === id);
      if (index === -1) {
        // text field doesn't exist yet, so create a new object
        return [
          ...textFields,
          {
            id,
            name,
            value,
            nodeid,
            costTypeNodeId,
            specifier,
            hasCostSourceNodeId,
          },
        ];
      } else {
        // text field already exists, so update its value
        const updatedTextField = {
          ...textFields[index],
          name,
          value,
          nodeid,
          costTypeNodeId,
          specifier,
          hasCostSourceNodeId,
        };
        return [
          ...textFields.slice(0, index),
          updatedTextField,
          ...textFields.slice(index + 1),
        ];
      }
    });
  };

  /* console.log(props.notification.notification,"====>CT") */

  let hasAuthorSigImage = props?.notification?.notification?.hasreport
    ? Object.keys(
        props?.notification?.notification?.hasreport[0]?.report
          ?.authorsignatureimage
      ).length
    : false;

  const costOrders = [
    "Kosten Teile",
    "Kosten Betriebsstoffe",
    "Kosten externe Dienstleister",
    "Stillstandszeit",
    "Personenstunden (intern)",
  ];

  useEffect(() => {
    if (units.length === 0) {
      props.getUnits("UNITS");
    }
  }, []);

  return (
    <>
      {navigate ? (
        <Navigate
          push
          to={withCurrentAccountPrefix(
            "/machine-overview?nodeid=" +
              encodeURIComponent(
                props?.notification?.notification?.isnotificationof[0]
                  ?.equipment?.nodeid
              ) +
              "&tab=1"
          )}
        />
      ) : null}

      <section style={{ padding: "28px 24px" }} className="costsSection">
        <header className={classes.sectionHeader}>
          <Grid
            container
            spacing={3}
            direction="row"
            justifyContent="space-between"
          >
            <Grid item>
              <Typography variant="h1">{i18n.protocol_title}</Typography>
            </Grid>
          </Grid>
        </header>

        <form className={_s(Theme247.form)}>
          <Grid
            container
            spacing={3}
            direction="row"
            justifyContent="space-between"
          >
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  {
                    <TextField
                      id="date"
                      label={"Durchgeführt am"}
                      type="date"
                      onChange={handleDate}
                      defaultValue={
                        props?.pageType == "edit" ? props?.date : creation_date
                      }
                      className={_s(Theme247.inputField)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  }
                </Grid>
                <Grid item xs={6}>
                  {
                    <TextField
                      id="time"
                      label={"Durchgeführt um"}
                      type="time"
                      onChange={handletime}
                      defaultValue={
                        props?.pageType == "edit"
                          ? moment(
                              props?.notification.notification.hasreport[0]
                                .report.executed
                            ).format("HH:mm")
                          : moment(Date.now()).format("HH:mm")
                      }
                      className={_s(Theme247.inputField)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                      variant="outlined"
                    />
                  }
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    multiline
                    rows="5"
                    onChange={(e) => {
                      setcomment(e.target.value);
                    }}
                    placeholder={i18n.protocol_comments}
                    className={classes.textarea}
                    variant="outlined"
                    defaultValue={
                      props && props?.pageType == "edit" ? props?.comment : ""
                    }
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <NotificationAttachments
                    from="notification"
                    rootNodeId={props?.notification?.notification?.nodeid}
                    // rootNodeId={props.equipmentNodeId}

                    edit={true}
                    fromChildToParentCallback={receiveChildValueAttachment}
                    specifier={"NotificationReportAttachment"}
                    nodeId={props?.reportnodeid}
                    workflowAttachments={
                      props && props?.pageType == "edit"
                        ? props?.attachments
                        : ""
                    }
                    attachmentsOf={"report"}
                  />
                </Grid>
              </Grid>

              <Divider
                variant="fullWidth"
                orientation="horizontal"
                sx={{ marginBottom: "42px" }}
              />

              <Accordion
                className="sigAccordian protokol-accordian"
                defaultExpanded
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography variant="h1" sx={{ color: "#38748D" }}>
                    {"Entstandene Aufwände"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item style={{ paddingTop: "10px" }}>
                      <div
                        className="MT_desc"
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        Der hier angegebene Aufwand kann dem Planaufwand zu
                        Analyse-Zwecken gegenübergestellt werden.
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} style={{}}>
                    {props && props.pageType == "edit"
                      ? props.costs &&
                        props.costs?.length > 0 &&
                        props.costs.map((ct, k) => {

                          const costName = ct?.cost?.name
                            ? ct?.cost?.name
                            : ct?.cost?.hascosttype[0].costtype.name;

                          return (
                            ct?.cost?.hascosttype[0].costtype.nodeid !== "247fn://247uptime.io/177c391e-a456-4263-8315-9eb230c4101c" ?
                            <>
                              {ct?.cost?.hascosttype &&
                              ct?.cost?.hascosttype[0]?.costtype?.unit
                                ?.unitid === "EUR" ? (
                                <Grid
                                  item
                                  xs={6}
                                  sx={{
                                    order: costOrders.indexOf(costName),
                                  }}
                                >
                                  <FormControl variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-cost-edit">
                                      {costName}
                                    </InputLabel>
                                    <OutlinedInput
                                      id="outlined-adornment-cost-edit"
                                      onChange={(event) =>
                                        handleTextFieldChange(
                                          props.notification?.notification
                                            ?.nodeid,
                                          "actualcost",
                                          k,
                                          ct?.cost?.nodeid,

                                          ct?.cost?.hascosttype[0]?.costtype
                                            ?.nodeid,
                                          costName,
                                          event.target.value
                                        )
                                      }
                                      defaultValue={ct?.cost?.value}
                                      label={costName}
                                      variant="outlined"
                                      // style={{ width: "50%" }}
                                      InputProps={{
                                        inputProps: {
                                          pattern: "[0-9]*",
                                          inputMode: "numeric",
                                          type: "number",
                                        },
                                      }}
                                      type={"text"}
                                      endAdornment={
                                        <InputAdornment position="end">
                                          (
                                          {
                                            units.filter(
                                              (unit) =>
                                                unit.unitId ===
                                                ct?.cost?.hascosttype[0]
                                                  ?.costtype?.unit?.unitid
                                            )[0]?.displayName.plural[store.language]
                                          }
                                          )
                                        </InputAdornment>
                                      }
                                    />
                                  </FormControl>
                                </Grid>
                              ) : (
                                ""
                              )}
                            </>
                            :""
                          );
                        })
                      : props.notification?.notification?.hascost &&
                        props.notification?.notification?.hascost.map(
                          (ct, k) => {

                            const costName = ct?.cost?.name
                            ? ct?.cost?.name
                            : ct?.cost?.hascosttype[0].costtype.name;

                            return (
                              ct?.cost?.hascosttype[0].costtype.nodeid !== "247fn://247uptime.io/177c391e-a456-4263-8315-9eb230c4101c" ?
                              <>
                                {units.filter(
                                  (unit) =>
                                    unit.unitId ===
                                    ct?.cost?.hascosttype[0].costtype?.unit
                                      ?.unitid
                                )[0]?.displayName?.plural[store.language] === "EUR" ? (
                                  <Grid
                                    item
                                    xs={6}
                                    style={{
                                      order: costOrders.indexOf(costName),
                                    }}
                                  >
                                    <FormControl
                                      variant="outlined"
                                      style={{ width: "100%" }}
                                    >
                                      <InputLabel htmlFor="outlined-adornment-cost-add">
                                        {costName}
                                      </InputLabel>
                                      <OutlinedInput
                                        id="outlined-adornment-cost-add"
                                        onChange={(event) =>
                                          handleTextFieldChange(
                                            props.notification?.notification
                                              ?.nodeid,
                                            "actualcost",
                                            k,
                                            ct?.cost?.nodeid,

                                            ct?.cost?.hascosttype[0]?.costtype
                                              ?.nodeid,
                                            costName,
                                            event.target.value
                                          )
                                        }
                                        variant="outlined"
                                        label={costName}
                                        InputProps={{
                                          inputProps: {
                                            pattern: "[0-9]*",
                                            inputMode: "numeric",
                                            type: "number",
                                          },
                                        }}
                                        type={"text"}
                                        endAdornment={
                                          <InputAdornment position="end">
                                            (
                                            {
                                              units.filter(
                                                (unit) =>
                                                  unit.unitId ===
                                                  ct?.cost?.hascosttype[0]
                                                    .costtype?.unit?.unitid
                                              )[0]?.displayName?.plural[store.language]
                                            }
                                            )
                                          </InputAdornment>
                                        }
                                      />
                                    </FormControl>
                                  </Grid>
                                ) : (
                                  ""
                                )}
                              </>
                              : ""
                            );
                          }
                        )}
                  </Grid>

                  <br />
                  <Divider />
                  <br />

                  <Grid container spacing={3}>
                    {props && props.pageType == "edit"
                      ? props.costs &&
                        props.costs?.length > 0 &&
                        props.costs.map((ct, k) => {

                          const costName = ct?.cost?.name
                          ? ct?.cost?.name
                          : ct?.cost?.hascosttype[0].costtype.name;

                          return (
                          
                            <>
                              {ct?.cost?.hascosttype &&
                              ct?.cost?.hascosttype[0]?.costtype?.unit
                                ?.unitid === "4740434" ? (
                                <Grid
                                  item
                                  xs={6}
                                  sx={{
                                    order: costOrders.indexOf(costName),
                                  }}
                                >
                                  <FormControl variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-cost-edit">
                                      {costName}
                                    </InputLabel>
                                    <OutlinedInput
                                      id="outlined-adornment-cost-edit"
                                      onChange={(event) =>
                                        handleTextFieldChange(
                                          props.notification?.notification
                                            ?.nodeid,
                                          "actualcost",
                                          k,
                                          ct?.cost?.nodeid,

                                          ct?.cost?.hascosttype[0]?.costtype
                                            ?.nodeid,
                                          costName,
                                          event.target.value
                                        )
                                      }
                                      defaultValue={ct?.cost?.value}
                                      label={costName}
                                      variant="outlined"
                                      // style={{ width: "50%" }}
                                      InputProps={{
                                        inputProps: {
                                          pattern: "[0-9]*",
                                          inputMode: "numeric",
                                          type: "number",
                                        },
                                      }}
                                      type={"text"}
                                      endAdornment={
                                        <InputAdornment position="end">
                                          (
                                          {
                                            units.filter(
                                              (unit) =>
                                                unit.unitId ===
                                                ct?.cost?.hascosttype[0]
                                                  ?.costtype?.unit?.unitid
                                            )[0]?.displayName?.plural[store.language]
                                          }
                                          )
                                        </InputAdornment>
                                      }
                                    />
                                  </FormControl>
                                </Grid>
                              ) : (
                                ""
                              )}
                            </>
                           
                          );
                        })
                      : props.notification?.notification?.hascost &&
                        props.notification?.notification?.hascost.map(
                          (ct, k) => {

                            const costName = ct?.cost?.name
                          ? ct?.cost?.name
                          : ct?.cost?.hascosttype[0].costtype.name;

                            return (

                              <>
                                {units.filter(
                                  (unit) =>
                                    unit.unitId ===
                                    ct?.cost?.hascosttype[0].costtype?.unit
                                      ?.unitid
                                )[0]?.displayName?.plural[store.language] === "Stunden" ? (
                                  <Grid
                                    className="hahahhaha"
                                    item
                                    xs={6}
                                    style={{
                                      order: costOrders.indexOf(costName),
                                    }}
                                  >
                                    <FormControl
                                      variant="outlined"
                                      style={{ width: "100%" }}
                                    >
                                      <InputLabel htmlFor="outlined-adornment-cost-add">
                                        {costName}
                                      </InputLabel>
                                      <OutlinedInput
                                        id="outlined-adornment-cost-add"
                                        onChange={(event) =>
                                          handleTextFieldChange(
                                            props.notification?.notification
                                              ?.nodeid,
                                            "actualcost",
                                            k,
                                            ct?.cost?.nodeid,

                                            ct?.cost?.hascosttype[0]?.costtype
                                              ?.nodeid,
                                            costName,
                                            event.target.value
                                          )
                                        }
                                        variant="outlined"
                                        label={costName}
                                        InputProps={{
                                          inputProps: {
                                            pattern: "[0-9]*",
                                            inputMode: "numeric",
                                            type: "number",
                                          },
                                        }}
                                        type={"text"}
                                        endAdornment={
                                          <InputAdornment position="end">
                                            (
                                            {
                                              units.filter(
                                                (unit) =>
                                                  unit.unitId ===
                                                  ct?.cost?.hascosttype[0]
                                                    .costtype?.unit?.unitid
                                              )[0]?.displayName?.plural[store.language]
                                            }
                                            )
                                          </InputAdornment>
                                        }
                                      />
                                    </FormControl>
                                  </Grid>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                          }
                        )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <div style={{ marginTop: "36px" }}></div>

              <Accordion
                className="sigAccordian protokol-accordian"
                defaultExpanded
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography variant="h1" sx={{ color: "#38748D" }}>
                    {"Bestätigung"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <div className="MT_desc">
                        Geben Sie Ihren Namen ein, um das Report zu
                        unterschreiben.
                      </div>
                    </Grid>

                    <Grid container spacing={3} sx={{ paddingLeft: "24px" }}>
                      <Grid item xs={6} sx={{ paddingTop: "16px !important" }}>
                        <FormControl
                          sx={{ margin: 0 }}
                          variant="standard"
                          fullWidth
                        >
                          <TextField
                            id="date"
                            label={"Datum und Uhrzeit"}
                            sx={{ width: "100%" }}
                            type="date"
                            defaultValue={createdDate}
                            onChange={handleCreatedDateChange}
                            // className={_s(Theme247.inputField)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled={
                              props && props?.pageType == "edit" ? true : false
                            }
                            variant="outlined"
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={6} style={{ paddingTop: "17px" }}>
                        <TextField
                          className={_s(Theme247.inputField)}
                          onChange={(e) => {
                            setRealName(e.target.value);
                          }}
                          defaultValue={realName}
                          disabled={
                            props && props?.pageType == "edit" ? true : false
                          }
                          placeholder="Reinhard Müller"
                          label={"Klarname"}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>

                    {hasAuthorSigImage ? (
                      <Grid container spacing={3} sx={{ paddingLeft: "24px" }}>
                        <Grid item xs={6}>
                          {" "}
                          <div className="fullNameSigImg">
                            <img
                              src={
                                props.notification.notification.hasreport[0]
                                  .report.authorsignatureimage.url
                              }
                            />
                            <div>Unterschrift</div>
                          </div>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid container spacing={3} sx={{ paddingLeft: "24px" }}>
                        <Grid item xs={6}>
                          <TextField
                            className={_s(Theme247.inputField)}
                            onChange={(e) => {
                              setFullName(e.target.value);
                            }}
                            value={fullname}
                            label={"Vorname und Nachname eingeben..."}
                            variant="outlined"
                            error={fullname === ""}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          {" "}
                          <div className="fullNameSig">{fullname}</div>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <div style={{ marginTop: "36px" }}></div>

              <Grid container spacing={3}>
                <Grid item xs={6}>
                  {noti_loader ? (
                    <CircularProgress className={classes.progressIndicator} />
                  ) : (
                    ""
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    disabled={
                      noti_loader ||
                      (!hasAuthorSigImage && fullname.length === 0) ||
                      createdDate === ""
                    }
                    onClick={submitForm}
                  >
                    {"wartung abschliessen"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </section>
    </>
  );
});
